import { render, staticRenderFns } from "./free_freight.vue?vue&type=template&id=57ed6526&scoped=true"
import script from "./free_freight.vue?vue&type=script&lang=js"
export * from "./free_freight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed6526",
  null
  
)

export default component.exports